module.exports = "<trackingresults></trackingresults>"


//////////////////
// WEBPACK FOOTER
// ./src/static/templates/results.view.html
// module id = 11
// module chunks = 0